import { useLoginState } from "./use-user-hooks";
import { convertLeagueClientRegion } from "../utils/region-helpers";

export interface SummonerInfo {
  gameName: string;
  tagLine: string;
  webRegion: string;
  isVerified?: boolean;
}

interface UseIsYearInReviewOwnerResult {
  isOwner: boolean;
}

export function useIsYearInReviewOwner(
  region: string,
  riotUserName: string,
  riotTagLine: string,
  summonerInfo: SummonerInfo | undefined,
): UseIsYearInReviewOwnerResult {
  const isLoggedIn = useLoginState();

  console.log("isVerified: ", summonerInfo?.isVerified);

  if (!isLoggedIn || !summonerInfo) {
    return { isOwner: false };
  }

  const { gameName, tagLine, webRegion, isVerified = true } = summonerInfo;

  if (!gameName || !tagLine || !webRegion || !isVerified) {
    return { isOwner: false };
  }

  const isOwner =
    convertLeagueClientRegion(webRegion).toLowerCase().trim() === region?.toLowerCase().trim() &&
    gameName.toLowerCase().trim() === riotUserName?.toLowerCase().trim() &&
    tagLine.toLowerCase().trim() === riotTagLine?.toLowerCase().trim();

  return { isOwner };
}
